import { Level } from '@nsalaun/ng-logger';

import { ApplicationNamesEnum, EnvironmentModel, StagesEnum } from '@svg/environment';

export const ENVIRONMENT: EnvironmentModel = {
	apiInfix: 'api.mysvg.de',
	applicationName: ApplicationNamesEnum.mySVG,
	clientId: 'mySVG',
	enabledUpdateServiceWorker: true,
	logLevel: Level.OFF,
	name: StagesEnum.PRODUCTION,
	scope: 'openid profile email',
	sentry: {
		url: 'https://1a4e9613a3e947c0ba5596c9f69d2744@o1347961.ingest.sentry.io/6631246',
		// default to halving transaction on prod for transactions not filtered more precisely
		tracesSampleRate: 0.5,
		replaysSessionSampleRate: 0,
		replaysOnErrorSampleRate: 0,
	},
	tokenIssuer: 'https://auth.svg.systems/realms/mysvg',
};
